import React, {useState} from 'react';
import DoNotDisturbAltIcon from "@mui/material/SvgIcon/SvgIcon";
import {IconButton} from "@mui/material";
import {toast} from "react-toastify";
import {showError} from "../../../utils/NotificationUtils";
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';

import {useIntegrationsContext} from "../../../api/integrations/IntegrationsContext";
import {DialogWindow} from "../../ui/DialogWindow";

interface Props {
    readonly item: any
}

export function IntegrationAuthFieldsItem({item}: Props) {
    const {IntegrationsApi} = useIntegrationsContext();
    const [deleted, setDeleted] = useState(false);
    const [showDialog, setShowDialog] = useState(false);

    const onDelete = () => {
        IntegrationsApi.deleteAuthFields({params: {fieldId: item.id}}).then(() => {
            toast.success("Deleted");
            setDeleted(true);
            setShowDialog(false);
        }).catch(err => {
            showError(err)
        })
    };

    return (
        <>
            {!deleted && (
                <tr>
                    <td>{item.label}</td>
                    <td>{item.code}</td>
                    <td>{item.type}</td>
                    <td>{!item.required ? <DoNotDisturbAltIcon/> : <CheckIcon/>}</td>
                    <td style={{width: 100}}>
                        <>
                            <IconButton onClick={() => {
                                setShowDialog(true)
                            }}>
                                <DeleteIcon/>
                            </IconButton>
                            <DialogWindow
                                show={showDialog}
                                onClose={() => setShowDialog(false)}
                                onCancel={() => console.log("hello")}
                                onAgree={onDelete}>
                                Are you sure?
                            </DialogWindow>
                        </>
                    </td>
                </tr>
            )}
        </>
    );
}

